









import { Component, Vue } from 'vue-property-decorator';

@Component
export default class NotFound extends Vue {
  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }
}
